import { UrlObject } from "url";

import { MouseEventHandler } from "react";

import { Link } from "@chakra-ui/next-js";
import {
  Box,
  ComponentWithAs,
  HStack,
  IconProps,
  ListIcon,
  ListItem,
  ListItemProps,
  Text,
  Tooltip,
} from "@chakra-ui/react";

import { ExternalLinkIcon } from "@/components/shared/ReleaseIcons";

type SidebarListItemProps = {
  collapsed?: boolean;
  icon: ComponentWithAs<"svg", IconProps>;
  isCurrent: boolean;
  label: string;
  href: string | UrlObject;
  external?: boolean;
  onClick?: MouseEventHandler | undefined;
} & ListItemProps;

function SidebarListItem({
  collapsed,
  icon,
  isCurrent,
  href,
  label,
  external = false,
  onClick = undefined,
  ...linkProps
}: SidebarListItemProps) {
  return (
    <Box h={14}>
      <Tooltip hasArrow isDisabled={!collapsed} label={label} placement="right">
        <ListItem
          key={label}
          aria-current={isCurrent && "page"}
          as={Link}
          h={12}
          href={href}
          my={0}
          px={3}
          target={external ? "_blank" : undefined}
          variant="buttonWrapper"
          w="auto"
          whiteSpace="nowrap"
          onClick={onClick}
          {...linkProps}
        >
          <HStack align="center" position="relative" w="full">
            <ListIcon as={icon} h={12} mr={0} />
            <Text flex={1} hidden={collapsed}>
              {label}
            </Text>
            {external && <ExternalLinkIcon display={collapsed ? "none" : "inline"} />}
          </HStack>
        </ListItem>
      </Tooltip>
    </Box>
  );
}

export default SidebarListItem;
